export const SENSITIVE="S JILGHJS BH8348R5"

export const MSG={

 PAYMENT_DETAIL:"There is an issue with your payment. Please make sure you have enough credit. Please wait 24 hours for this issue to resolve automatically. If this issue persists, please reach out to support.",
 MORE_MEETING:"You can only schedule only one meeting in the free trial. Please cancel the existing meeting to schedule another appointment or buy a subscription to schedule more appointments."

}
export const MOBILE_VIEW_WIDTH=768
export const DEFAULT_USER_IMAGE='/img/defaultProfileImage.png'
export const TYPE_OF_LEAVE = ["Casual leaves", "Sick leaves"]
export const LEAVE_STATUS = ["All", "Approved", "Rejected"]
export const LEAVE_TYPE = ["All", "Casual leaves", "Sick leaves",]
export const TOTAL_CASUAL_LEAVE = 22
export const TOTAL_SICK_LEAVE = 6
export const TOTAL_HOLIDAY = 28
export const MENU_PROFILE_ICON='/img/profileIcon.png'
export const MENU_HOME_ICON='/img/homeIcon.png'
export const MENU_CHAT_ICON='/img/chat.png'
export const MENU_SIGN_OUT_ICON='/img/signOut.png'
export const MENU_SETTING_ICON='/img/settings.png'
export const MENU_TIME_OFF_ICON='/img/timeOffIcon.png'
export const MENU_CLOSE_ICON='/img/cross.png'
export const MENU_SUBSRCRIPTION_ICON='/img/menuSubscription.png'

// export const TOTAL_CASUAL_LEAVE_PER_MONTH = 1.8
// export const TOTAL_SICK_LEAVE_PER_MONTH = 0.5

export const MIN_CASUAL_LEAVE = 8
export const MAX_CASUAL_LEAVE = 30
